import useIconSet from '../getIconSet';
export var getIcon = function (name) {
    var icons = useIconSet();
    return icons[name];
};
export default getIcon;
//# sourceMappingURL=index.js.map